import { useApiClient } from "@/composables/useApiClient";
import { defineStore } from "pinia";

interface DailyVisitState {
  lastVisitDate: string | null;
}

export const useDailyVisitStore = defineStore("dailyVisit", {
  state: (): DailyVisitState => ({
    lastVisitDate: null,
  }),
  actions: {
    async trackDailyVisit() {
      const today = new Date().toISOString().slice(0, 10);

      // Only track if we haven't tracked today yet
      if (this.lastVisitDate !== today) {
        const { dailyUserVisits } = useApiClient();

        try {
          await dailyUserVisits.createDailyUserVisit();
          this.lastVisitDate = today;
        } catch (error) {
          console.error("Error tracking daily visit:", error);
        }
      }
    },
  },
});
